// IMPORTS
// Modules
import { Link } from 'react-router-dom';
import $ from 'jquery';
// Assets
import './../scss/OHSApp.scss';
import { OHSVariables } from './_variables';
import icon_menu_light from './../icons/menu_light.svg';
import icon_menu_dark from './../icons/menu_dark.svg';
import icon_help_light from './../icons/help_light.svg';
import icon_help_dark from './../icons/help_dark.svg';
import icon_arrow_light from './../icons/arrow_light.svg';
import icon_arrow_dark from './../icons/arrow_dark.svg';


// FUNCTIONS
function OHSAppNavToggle () {
   var container = document.getElementById('ohsapp');
   if (container.classList.contains("ohsapp-nav-show")) {
      container.classList.remove("ohsapp-nav-show");
      container.classList.add("ohsapp-nav-hide");
   } else if (container.classList.contains("ohsapp-nav-hide")) {
      container.classList.remove("ohsapp-nav-hide");
      container.classList.add("ohsapp-nav-show");
   } else {
      if (window.innerWidth <= OHSVariables.breakpoint) {
         container.classList.remove("ohsapp-nav-hide");
         container.classList.add("ohsapp-nav-show");
      } else {
         container.classList.remove("ohsapp-nav-show");
         container.classList.add("ohsapp-nav-hide");
      }
   }
}


// COMPONENT
export default function OHSApp (props) {
   // Functions
   const toggleDropdown = function (container) {
      // Toggle Sublinks
      $('#' + container + ' .ohsapp-nav-sublinks-content').each(function () {
         $(this).toggle(200);
      });

      // Rotate Arrow
      $('#' + container + ' .ohsapp-nav-sublinks-header-right img').each(function () {
         if ($(this).css("transform") != "none") {
            $(this).css({"transform": ""});
         } else {
            $(this).css({"transform": "rotate(180deg)"});
         }
      });
   }

   // Component
   return (
      <div id='ohsapp' className="ohsapp">
         <nav>
            {props.logo ? <div className='ohsapp-nav-logo'>
               <Link to={props.logolink}>
                  <img src={props.logo} alt="Product Logo" />
               </Link>
            </div> : null}
            {props.navigation ? props.navigation.length > 0 ? props.navigation.map(function (section, i) {
               return (
                  <div key={`ohsapp-nav-section-${i}`} className='ohsapp-nav-section'>
                     <p>{section.title}</p>
                     <div className='ohsapp-nav-links'>
                        {section.links ? section.links.length > 0 ? section.links.map(function (link, j) {
                           return(
                              <div key={`ohsapp-nav-link-${i}-${j}`} id={`ohsapp-nav-sublinks-${i}-${j}`} className='ohsapp-nav-linkwrapper'>
                                 {link.sublinks ? link.sublinks.length > 0 ?
                                    <div className='ohsapp-nav-sublinks'>
                                       <div className='ohsapp-nav-sublinks-header' onClick={() => {toggleDropdown(`ohsapp-nav-sublinks-${i}-${j}`)}}>
                                          <div className='ohsapp-nav-sublinks-header-left'>
                                             {link.icon ? <img src={link.icon} alt="Link Icon" /> : null}
                                             <p>{link.title}</p>
                                          </div>
                                          <div className='ohsapp-nav-sublinks-header-right'>
                                             <img src={props.onehive.theme === props.onehive.themes.light ? icon_arrow_dark : icon_arrow_light} alt="Arrow Icon" />
                                          </div>
                                       </div>
                                       <div className='ohsapp-nav-sublinks-content' style={{display: "none"}}>
                                          {link.sublinks.map(function (sublink, k) {
                                             return (
                                                <div key={`ohsapp-nav-sublink-${i}-${j}-${k}`} className='ohsapp-nav-sublinks-link'>
                                                   {sublink.icon ? <img src={sublink.icon} alt="Link Icon" /> : null}
                                                   <Link to={sublink.link}>{sublink.title}</Link>
                                                </div>
                                             );
                                          })}
                                       </div>
                                    </div>
                                 : null :
                                    <div className='ohsapp-nav-link'>
                                       {link.icon ? <img src={link.icon} alt="Link Icon" /> : null}
                                       <Link to={link.link}>{link.title}</Link>
                                    </div>
                                 }
                              </div>
                           );
                        }) : null : null}
                     </div>
                  </div>
               );
            }) : null : null}
         </nav>
         <main>
            {props.children}
         </main>
      </div>
   );
};

export function OHSAppHeader (props) {
   // Component
   return (
      <div className="ohsapp-header">
         <div className='ohsapp-header-title'>
            <div className='ohsapp-header-title-left'>
               <img src={props.onehive.theme === props.onehive.themes.light ? icon_menu_dark : icon_menu_light} alt="Menu Icon" onClick={OHSAppNavToggle} />
               <p>{props.title}</p>
            </div>
            {props.help && <div className='ohsapp-header-title-right'>
               <Link to={props.help} target={'_blank'}>
                  <img src={props.onehive.theme === props.onehive.themes.light ? icon_help_dark : icon_help_light} alt="Help Icon" />
               </Link>
            </div>}
         </div>
         <hr />
      </div>
   );
}

export function OHSAppBody (props) {
   // Component
   return (
      <div className="ohsapp-body">
         {props.children}
      </div>
   );
}

export function OHSAppFooter () {
   // States and Variables
   const date = new Date();

   // Component
   return (
      <div className="ohsapp-footer">
         <hr />
         <p>&copy; {date.getFullYear()} OneHive Systems LLC - All rights reserved.</p>
         <a href='https://www.onehivesystems.com/' target='_blank'>Visit our Website</a>
      </div>
   );
}